export default {
  getOrganization (state) {
    return state.organization
  },
  getTrashOrganization (state) {
    return state.trash.organizations
  },
  getTrashTotal (state) {
    return state.trash.total
  },
  getTrashLastPage (state) {
    return state.trash.last_page
  },
  getTrashResult (state) {
    return state.trash.result
  },
  getOpenView (state) {
    return state.open_view
  },
  getOpenCreateChildren (state) {
    return state.open_create_children
  },
  getOpenEdit (state) {
    return state.open_edit
  },
  getOpenUser (state) {
    return state.open_user
  }
}



// WEBPACK FOOTER //
// ./src/store/module/organization/getters.js